var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPolygon6Stroke(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 100,
    viewBox: "0 0 228 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.794 98.3557C228.07 98.834 227.906 99.4458 227.428 99.7219C226.949 99.998 226.338 99.834 226.061 99.3557L170.101 2.42798L58.7558 2.42797L2.79388 99.3557C2.51774 99.834 1.90596 99.998 1.42767 99.7219C0.979198 99.463 0.806667 98.9089 1.01458 98.4465L1.06146 98.3557L57.6005 0.427971L171.255 0.427976L227.794 98.3557Z",
    fill: "url(#paint0_linear_68_195)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_195",
    x1: 114.428,
    y1: -13.6443,
    x2: 114.428,
    y2: 211.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57C4AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E74D4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon6Stroke);
export default __webpack_public_path__ + "static/media/Polygon 6 (Stroke).cd81d04d9e648a214e11d33457e68d91.svg";
export { ForwardRef as ReactComponent };